import { render, staticRenderFns } from "./DeviceSettings.vue?vue&type=template&id=c6cf4858&scoped=true"
import script from "./DeviceSettings.vue?vue&type=script&lang=ts"
export * from "./DeviceSettings.vue?vue&type=script&lang=ts"
import style0 from "./DeviceSettings.vue?vue&type=style&index=0&id=c6cf4858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cf4858",
  null
  
)

export default component.exports